import React, { useState, useRef } from 'react';
import { gql, useQuery, useMutation } from '@apollo/client';
import FormBuilder from 'global/components/FormBuilder/index';
import ESPAÑOL from "./ESPAÑOL";
import ENGLISH from "./ENGLISH";
const CONTENTS = {
  ESPAÑOL,
  ENGLISH
}






const FORM_FIELDS = (CONTENT)=>{
  return(
    [ //defaultValuePath used to set default value form CONTENTect
      {
        title: <div className="formTitle"><span className="">{CONTENT[3]}</span></div>,
        subTitle: <div className="formSubTitle"><span className="">{CONTENT[4]}</span></div>,
        type: "text",
        name: "firstName",
        required: true,
        defaultValue: "",
        defaultValuePath: "firstName",
        errorMessage: CONTENT[5]
      },
      {
        title: <div className="formTitle"><span className="">{CONTENT[6]}</span></div>,
        subTitle: <div className="formSubTitle"><span className="">{CONTENT[7]}</span></div>,
        type: "text",
        name: "lastName",
        required: true,
        defaultValue: "",
        defaultValuePath: "lastName",
        errorMessage: CONTENT[8]
      },
      {
        title: <div className="formTitle"><span className="">{CONTENT[9]}</span></div>,
        subTitle: <div className="formSubTitle"><span className="">{CONTENT[10]}</span></div>,
        type: "email",
        name: "email",
        required: true,
        defaultValue: "",
        checkAvailable: true,
        defaultValuePath: "email",
        errorMessage: CONTENT[11]
      },
      {
        title: <div className="formTitle"><span className="">{CONTENT[12]}</span></div>,
        subTitle: <div className="formSubTitle"><span className="">{CONTENT[13]}</span></div>,
        type: "phone",
        name: "phone",
        required: true,
        defaultValue: "",
        defaultValuePath: "phone",
        errorMessage: CONTENT[14]
      },
      {
        title: <div className="formTitle"><span className="">{CONTENT[15]}</span></div>,
        subTitle: <div className="formSubTitle"><span className="">{CONTENT[16]}</span></div>,
        type: "password",
        name: "newPassword",
        required: false,
        defaultValue: "",
        defaultValuePath: "newPassword"
      }
    ]
  )
};



class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      updateIsValid: false,
      curObj: {...this.props.curObj}
    };    
  }

  onSubmit = async() => {
    var {curObj} = this.state;
    await this.props.onUpdateUser(curObj, window.ForceUserReload);
    return true;
  }

  render(){
    var {updateIsValid, curObj} = this.state;
    const CONTENT = window.GlobalUtil.dangerSetGlobal(CONTENTS[window.Session.Language]); 
    return(
      <i className="fas fa-pencil-alt" onClick={(e)=>{
        e.preventDefault();
        window.GlobalUtil.triggerEvent("SlideInRightEvent", {
          TITLE: this.props.CONTENT[0],
          closeButtonText: this.props.CONTENT[1],
          saveButtonText: this.props.CONTENT[2],
          customClass: "frontEndSlideInRight shortSlideInRight",
          width: "700px",
          onSave: this.onSubmit,
          children: (props)=>{                                      
            return(
              <FormBuilder
                {...props} 
                disableKeySubmit={true}
                initialValues={curObj}
                listOfFields={FORM_FIELDS(CONTENT)}
                onSubmit={this.onSubmit}
                onChange={newObj => this.setState({curObj: newObj})}
                onValidate={props.onChangeValid}
              />
            )
          }
        });
      }} />
    )
  }
}


export default Index;
      
